import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";

import { VerticalLayoutModule } from "app/layout/vertical/vertical-layout.module";
import { HorizontalLayoutModule } from "app/layout/horizontal/horizontal-layout.module";
import { KeyboardComponent } from "./keyboards/keyboard/keyboard.component";
import { NumpadComponent } from "./keyboards/numpad/numpad.component";
import { KeyboardService } from "app/services/keyboard.service";

const ROUTES: Routes = [
  {
    path: "keyboard/:inputId/:value",
    component: KeyboardComponent,
  },
  {
    path: "keyboard/:inputId",
    component: KeyboardComponent,
  },
  {
    path: "numpad/:inputId/:value",
    component: NumpadComponent,
  },
  {
    path: "numpad/:inputId",
    component: NumpadComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    VerticalLayoutModule,
    HorizontalLayoutModule,
    FormsModule,
    RouterModule.forChild(ROUTES)
  ],
  providers: [KeyboardService],
  exports: [
    VerticalLayoutModule,
    HorizontalLayoutModule,
    KeyboardComponent,
    NumpadComponent,
  ],
  declarations: [KeyboardComponent, NumpadComponent],
})
export class LayoutModule {}
